import { Box, Flex, Grid, Text } from '@chakra-ui/react';

import TextAreaComp from '@components/formField/TextAreaComp';
import Select from '@components/filter/select';
import DatePickerComp from '@components/datePicker';
import InputComp from '@components/formField/InputComp';
import { detailItem, detailItemTag } from '../../../utils/components';
import useGetSchemeList from '@pages/ConsumerPromotion/hooks/query/useGetSchemeList';
import { HELPER_TEXT, PLACEHOLDER, STATUS } from '@pages/ConsumerPromotion/utils/const';
import { usePromotionClaim } from '@pages/ConsumerPromotion/hooks/state/usePromotionClaim';
import { dateFormatter } from '@helpers/utils';

export default function EditingForm({ data, invalidFields }) {
    const state = usePromotionClaim();
    const promotion_scheme = useGetSchemeList();
    const variant = STATUS[data?.promotion_status.status?.toLowerCase?.()] || 'draft';

    const fields = [
        { label: 'Status', value: data?.promotion_status.status ?? 'Draft', variant: variant },
        {
            label: 'SKU Associated',
            value: data?.total_sku === 0 ? 'Belum di isi' : data?.total_sku,
            isError: data?.total_sku === 0 ? true : false,
            type: data?.total_sku === 0 && 'tag',
        },
        {
            label: 'Customers',
            value: data?.total_customer === 0 ? 'Belum di isi' : data?.total_customer,
            isError: data?.total_customer === 0 ? true : false,
            type: data?.total_customer === 0 && 'tag',
        },
        { label: 'Created by', value: data?.created_by_name },
        { label: 'Created Date', value: dateFormatter(data?.created_at) },
    ];

    return (
        <Box>
            <Grid templateColumns="repeat(2, 1fr)" gap={'16px'} gridColumnGap={'56px'}>
                {detailItemTag(fields[0])}

                <Box></Box>

                <Flex alignItems={'start'} gap={'16px'}>
                    <Text fontSize={'xs'} fontWeight={'700'} flex={1} mt={'8px'}>
                        Promotion Name
                    </Text>
                    <Box flex={2.3}>
                        <TextAreaComp
                            label=""
                            placeholder={PLACEHOLDER.promotion_name}
                            value={state.promotion_name}
                            onChange={(value) => {
                                state.set({ promotion_name: value });
                            }}
                            isInvalid={invalidFields.promotion_name}
                            helperText={invalidFields.promotion_name && HELPER_TEXT.promotion_name}
                            debounceDelay={0}
                        />
                    </Box>
                </Flex>

                <Box></Box>

                <Flex alignItems={'start'} gap={'16px'}>
                    <Text fontSize={'xs'} fontWeight={'700'} flex={1} mt={'8px'}>
                        Promo Scheme
                    </Text>
                    <Box flex={2.3}>
                        <Select
                            isLabelLeft
                            title=""
                            placeholder={PLACEHOLDER.promotion_scheme?.scheme}
                            isMultiple={false}
                            isCanSearch={false}
                            selected={state.promotion_scheme}
                            refetchData={promotion_scheme?.refetch}
                            data={promotion_scheme?.data?.listScheme}
                            isLoading={promotion_scheme?.isLoading}
                            onChangeFilter={(value) => state.set({ promotion_scheme: value })}
                            isInvalid={invalidFields.promotion_scheme}
                            helperText={invalidFields.promotion_scheme && HELPER_TEXT.promotion_scheme}
                        />
                    </Box>
                </Flex>

                <Flex alignItems={'start'} gap={'16px'}>
                    <Text fontSize={'xs'} fontWeight={'700'} flex={1} mt={'8px'}>
                        No. PM
                    </Text>
                    <Box flex={2.3}>
                        <InputComp
                            label=""
                            placeholder={PLACEHOLDER.tfm_id}
                            value={state.tfm_id}
                            onChange={(value) => {
                                state.set({ tfm_id: value });
                            }}
                            isInvalid={invalidFields.tfm_id}
                            helperText={invalidFields.tfm_id && HELPER_TEXT.tfm_id}
                            debounceDelay={0}
                        />
                    </Box>
                </Flex>

                <Flex alignItems={'start'} gap={'16px'}>
                    <Text fontSize={'xs'} fontWeight={'700'} flex={1} mt={'8px'}>
                        Start Date
                    </Text>
                    <Box flex={2.3}>
                        <DatePickerComp
                            label=""
                            value={dateFormatter(state.start_date)}
                            maxDate={state.end_date}
                            isIconRight
                            onChange={(date) => {
                                state.set({ start_date: date });
                            }}
                            isInvalid={invalidFields.start_date}
                            helperText={invalidFields.start_date && HELPER_TEXT.start_date}
                        />
                    </Box>
                </Flex>

                <Flex alignItems={'start'} gap={'16px'}>
                    <Text fontSize={'xs'} fontWeight={'700'} flex={1} mt={'8px'}>
                        End Date
                    </Text>
                    <Box flex={2.3}>
                        <DatePickerComp
                            label=""
                            value={dateFormatter(state.end_date)}
                            minDate={state.start_date}
                            isIconRight
                            onChange={(date) => {
                                state.set({ end_date: date });
                            }}
                            isInvalid={invalidFields.end_date}
                            helperText={invalidFields.end_date && HELPER_TEXT.end_date}
                        />
                    </Box>
                </Flex>

                {fields.slice(1).map((f, idx) => {
                    if (f.type === 'spacer') {
                        return <Box key={idx} />;
                    }

                    if (f.type === 'tag') {
                        return detailItemTag(f, idx);
                    }

                    return detailItem(f, idx);
                })}
            </Grid>
        </Box>
    );
}
